__turbopack_context__.v({
  "copy": "BlockSectionHeading-module-scss-module__ieiuTa__copy",
  "cta": "BlockSectionHeading-module-scss-module__ieiuTa__cta",
  "flushBottom": "BlockSectionHeading-module-scss-module__ieiuTa__flushBottom",
  "flushTop": "BlockSectionHeading-module-scss-module__ieiuTa__flushTop",
  "hasCopy": "BlockSectionHeading-module-scss-module__ieiuTa__hasCopy",
  "inner": "BlockSectionHeading-module-scss-module__ieiuTa__inner",
  "lockup": "BlockSectionHeading-module-scss-module__ieiuTa__lockup",
  "paragraph": "BlockSectionHeading-module-scss-module__ieiuTa__paragraph",
  "root": "BlockSectionHeading-module-scss-module__ieiuTa__root",
  "textAlignLeft": "BlockSectionHeading-module-scss-module__ieiuTa__textAlignLeft",
});
